import { oldApiInstance } from 'functions/request';

export const fetchPromoStoreCouponsApi = ({ ruleId, page, perPage }) => {
  return oldApiInstance.get(`shop/popular_rules/${ruleId}/coupons?page=${page}&per_page=${perPage}`);
};
